import React from "react";
import { DividerType, LayoutType } from "../../utils/baseTypes";
import { Section } from "../Global/Section";
import Divider from "../Divider/Divider";
import { Content } from "../Global/Content";

type TableLayoutType = LayoutType & {
  modul_width: "normal-frame" | "narrow-frame";
};

export type TableModuleType = {
  acf_fc_layout: "table";
  table: {
    divider: DividerType;
    headline: string;
    htype_tag: "h2" | "h3";
    content: string;
    table: TableType;
  };
  layout: TableLayoutType;
};

export type TableType = {
  number_columns: string;
  table_heads: {
    table_head_1: string;
    table_head_2: string;
    table_head_3: string;
    table_head_4: string;
    table_head_5: string;
  };
  table_row: {
    table_row_1: string;
    table_row_2: string;
    table_row_3: string;
    table_row_4: string;
    table_row_5: string;
  }[];
  footer: string;
};

export interface TableProps {
  data: TableModuleType;
}

export const Table = ({ data }: TableProps) => {
  const { abstand, background, id, modul_width } = data.layout;
  const gap = abstand === "default" ? "" : abstand;
  const { divider, table } = data.table;
  const { headline, htype_tag, content } = data.table;

  const getColumns = <T,>(obj: { [k: string]: T }, name: string): T[] => {
    const number = table.number_columns;
    return Array(Number(number))
      .fill(0)
      .map((_, i) => {
        return obj[name + "_" + (i + 1)];
      });
  };

  const headVariables = getColumns(table.table_heads, "table_head")
    .map((e, key) => {
      return { ["--column-" + (key + 1) + "-head"]: `"${e}: "` };
    })
    .reduce((prev, curr) => {
      return {
        ...prev,
        ...curr,
      };
    }, {});
  return (
    <Section
      className={`table-mod ${background} ${gap}`}
      columnsClassName="is-multiline is-centered"
      style={headVariables}
      id={id}
    >
      {divider.divider_on && (
        <div className="column is-12">
          <Divider data={divider} background={background} />
        </div>
      )}

      <div
        className={`column ${
          modul_width === "narrow-frame" ? "is-12 is-8-widescreen" : "is-12"
        }`}
      >
        <div className="columns is-multiline">
          <div className="column is-12">
            <Content
              hpos={"headline-over-text"}
              tpos={""}
              htype={htype_tag}
              headline={headline}
              text={content ?? ""}
              link={false}
              ctapos=""
              number_cols=""
              cta_type={"link"}
            />
          </div>
          <div className="column is-12">
            <table>
              <thead>
                <tr>
                  {getColumns(table.table_heads, "table_head").map(
                    (column, key) => {
                      return <th key={key}>{column}</th>;
                    }
                  )}
                </tr>
              </thead>
              <tbody>
                {table.table_row &&
                  table.table_row.map((row, key) => {
                    return (
                      <tr className="table-row" key={key}>
                        {getColumns(row, "text").map((column, key) => {
                          return <td key={key}>{column}</td>;
                        })}
                      </tr>
                    );
                  })}
              </tbody>
              <tfoot>
                <tr>
                  <td
                    className="has-text-right note px-0"
                    colSpan={Number(table.number_columns)}
                  >
                    {table.footer}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </Section>
  );
};
